import React from 'react';
import { useParams } from 'react-router-dom';

const users = {
  1: { name: 'Berges Aronis' },
  2: { name: 'Rony' },
  3: { name: 'Jehan' },
};

function UserPage() {
  const { userId } = useParams();
  const user = users[userId];

  if (!user) {
    return <div>User not found</div>;
  }

  return (
    <div>
      <h1>{user.name}</h1>
      <p>User ID: {userId}</p>
    </div>
  );
}

export default UserPage;